module.exports = __webpack_public_path__ + "media/images/vlees_aan_een_stuk_productoverzicht-d64b430af0e9688c48e2dc5b43b41277.jpg";